import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {SkillName} from './skills.enums';
import {Skill} from './skills.types';

const registry = new Map<SkillName, Skill>();

function registerSkill(skill: Skill): void {
  registry.set(skill.name, skill);
}

function getSkillByName(name: SkillName): Skill | undefined {
  return registry.get(name);
}

function getAllSkills(): Skill[] {
  return Array.from(registry.values());
}

function getSkillsForBreadcrumbs(breadcrumbs: BreadcrumbName[]): Skill[] {
  const activeBreadcrumbs = new Set(breadcrumbs);

  function deepestMatchingBreadcrumbIndex(skill: Skill): number {
    return Math.max(
      ...skill.applicableBreadcrumbs
        .filter((bc) => activeBreadcrumbs.has(bc))
        .map((bc) => breadcrumbs.indexOf(bc)),
    );
  }

  return getAllSkills()
    .filter((skill) => skill.applicableBreadcrumbs.some((bc) => activeBreadcrumbs.has(bc)))
    .sort((a, b) => deepestMatchingBreadcrumbIndex(b) - deepestMatchingBreadcrumbIndex(a));
}

function resetRegistry(): void {
  registry.clear();
}

export {
  registerSkill,
  getSkillByName,
  getAllSkills,
  getSkillsForBreadcrumbs,
  resetRegistry,
};
